<template>
  <div class="blank-layout">
    <router-view></router-view>
  </div>
</template>
